// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.empty-content[data-v-31d61ee2]{height:100%;display:flex}`, "",{"version":3,"sources":["webpack://./src/components/EmptyMailboxSection.vue"],"names":[],"mappings":"AACA,gCACC,WAAA,CACA,YAAA","sourcesContent":["\n.empty-content {\n\theight: 100%;\n\tdisplay: flex;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
